var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartCatalogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.66667C2.5 3.40959 2.5 2.78105 2.89052 2.39052C3.28105 2 3.90959 2 5.16667 2H11.8333C13.0904 2 13.719 2 14.1095 2.39052C14.5 2.78105 14.5 3.40959 14.5 4.66667V11.3333C14.5 12.5904 14.5 13.219 14.1095 13.6095C13.719 14 13.0904 14 11.8333 14H5.16667C3.90959 14 3.28105 14 2.89052 13.6095C2.5 13.219 2.5 12.5904 2.5 11.3333V4.66667Z",
    stroke: "#6921C4",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.6665H4.5C5.15428 4.6665 5.48142 4.6665 5.76295 4.80727C6.04448 4.94803 6.24076 5.20974 6.63333 5.73317L7.03333 6.2665C7.4259 6.78993 7.62219 7.05164 7.90372 7.19241C8.18524 7.33317 8.51238 7.33317 9.16667 7.33317H12.5C13.1213 7.33317 13.4319 7.33317 13.6769 7.23168C14.0036 7.09635 14.2632 6.83679 14.3985 6.51008C14.5 6.26505 14.5 5.95443 14.5 5.33317V5.33317",
    stroke: "#6921C4",
    strokeWidth: 1.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1665 10.6665H10.4998",
    stroke: "#6921C4",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartCatalogIcon);
export default __webpack_public_path__ + "static/media/partCatalogIcon.fff79cf3.svg";
export { ForwardRef as ReactComponent };